import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-slate-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full" style={{
          backgroundImage: "radial-gradient(circle at 2px 2px, white 1px, transparent 0)",
          backgroundSize: "40px 40px",
        }}></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 md:px-6 text-center relative z-10">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-5 leading-tight">
          Don&apos;t Let Confusion Cost You Your Future
        </h2>
        <p className="text-base md:text-lg text-slate-300 max-w-3xl mx-auto mb-8 leading-relaxed">
          The wrong insurance plan can leave you underinsured when you need it most.
          Get a free consultation with our experts and buy the right plan with confidence.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <Link
            to="/book-appointment?source=Homepage"
            className="w-full sm:w-auto bg-cta-600 hover:bg-cta-700 text-white font-bold text-sm md:text-base px-8 py-4 rounded-full shadow-lg shadow-cta-600/30 hover:shadow-xl transition-all hover:-translate-y-0.5 whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-calendar-check-line text-lg"></i>
            Book Free Consultation
          </Link>
          <a
            href="https://wa.me/919999365655?text=Hi%20ExpertAdvise%2C%20I%20want%20to%20discuss%20insurance%20options"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto bg-white hover:bg-white/90 text-slate-900 font-bold text-sm md:text-base px-8 py-4 rounded-full shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5 whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-whatsapp-line text-lg text-green-600"></i>
            Chat on WhatsApp
          </a>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-4 md:gap-8 text-slate-400 text-xs md:text-sm">
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-cta-400"></i>
            No Spam Calls
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-cta-400"></i>
            100% Free Consultation
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-cta-400"></i>
            No Obligation to Buy
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-cta-400"></i>
            Unbiased Recommendations
          </span>
        </div>
      </div>
    </section>
  );
}